export default __webpack_public_path__ + "static/media/wordprez-negative.e904c014.svg";